import logo from "./logo.svg";
// import '../node_modules/bootstrap/dist/js/bootstrap.bundle'
import { React, useState, useEffect } from "react";
import "./App.css";
import Posts from "./Posts/Posts";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./Componant/Login/Login";
import Otp from "./Componant/Login/Otp";
import AllPosts from "./Componant/AllPosts/AllPosts";
import ResultsPage from "./Componant/AllPosts/ResultsPage";
import SearchLandingPage from "./Componant/AllPosts/SearchLandingPage";
import TablePosts from "./Componant/AllPosts/TablePosts";
import SinglePost from "./Componant/AllPosts/SinglePost";
import Footer from "./Componant/Footer/Footer";
import CreateScript from "./ScriptFile/CreateScript";
import TablePost2nd from "./Componant/AllPosts/TablePost2nd";
// import Postedit from "./Componant/AllPosts/Postedit";
import SearchResults from "./Componant/AllPosts/SearchResults";
import OpSearchResults from "./Componant/AllPosts/OpSearchResults";
import TopArrowButton from "./Componant/TopArrowButton";
import SingleArticle from "./Componant/AllPosts/SingleArticle";
import CreatePost from "./Componant/CreatePosts/CreatePost";
import CreateNewUserForm from "./Componant/Login/CreateNewUserForm";
import CreateUsersUsingCsv from "./Componant/Login/CreateUsersUsingCsv";
import PostCreator from "./Posts/PostCreator";
import Editor from "./Componant/Editor";
import JiraIntegration from "./Componant/JiraIntegration";
import ImageUpload from "./Componant/ImageUpload";
import EditPostPage from "./Componant/AllPosts/EditPostPage ";
import EditPostScreen from "./Componant/EditPostScreen";
import GetAllCat from "./Componant/AllPosts/GetAllCat";
import GetAllNew from "./Componant/AllPosts/GetAllNew";
import CsvDownloader from "./Componant/AllPosts/CsvDownloader";
import { useContext } from "react";
import GlobalContext from "./context/GlobalContext";
import SubcategoryContainer from "./Componant/SubcategoryContainer";
import CreateCatagory from "./Componant/Login/CreateCatagory";
// import { useState } from "react";
import CategoryPosts from "./Componant/AllPosts/CategoryPosts";
import CreateCategories from "./Componant/AllPosts/CreateCategories";
import NewEdiitorImportWord from "./Componant/NewEdiitorImportWord";
import WigetAdmin from "./Componant/AllPosts/WigetAdmin";
import ShowSubCategory from "./Componant/AllPosts/ShowSubCategory";
import BackupTable from "./Componant/AllPosts/BackupTable";
import GlobalLogo from "./Componant/GlobalLogo";
import CreateTags from "./Componant/AllPosts/CreateTags";
import AnaliticsDasboard from "./Componant/AllPosts/AnaliticsDasboard";
import OpAnaliticsDasboard from "./Componant/AllPosts/OpAnaliticsDasboard";
import Notifications from "./Componant/Notifications";
import BroadCast from "./Componant/BroadCast";
import KrLanding from "./Componant/KrLanding";
import CreateOraUsers from "./Componant/CreateOraUsers";
import WidgetSingleArticles from "./Componant/AllPosts/WidgetSingleArticles";
import LoggerFile from "./Componant/AllPosts/LoggerFile";
import SetOpenPlatform from "./Componant/SetOpenPlatform";
// import InitalizeWidget from "./Componant/widget/InitializeWidget.jsx";
import axios from "axios";
import OpenPlatformSearchLandingPage from "./Componant/AllPosts/OpenPlatformSearchLandingPage";
import { API_BASE_URL } from "./utils/config";
import OpenPlatformShowSubCategory from "./Componant/AllPosts/OpenPlatformShowSubCategory";
import OpenPlatformSingleArticle from "./Componant/AllPosts/OpenPlatformSingleArticle";
import OpenPlatformCategoryPost from "./Componant/AllPosts/OpenPlatformCategoryPost";
import { Container, Spinner } from "react-bootstrap";
import WordPressPosts from "./Componant/Footer/WordPressPosts";
import ShowCatInf from "./Componant/AllPosts/ShowCatInf";
import SearchLandingPageNew from "./Componant/AllPosts/SearchLandingPageNew";
import ShowSubCategoryNew from "./Componant/AllPosts/ShowSubCategoryNew";
import CategoryPostsNew from "./Componant/AllPosts/CategoryPostsNew";
import SearchResultesNew from "./Componant/AllPosts/SearchResultesNew";
import OpenPltformSearchLandingPageNew from "./Componant/AllPosts/OpenPltformSearchLandingPageNew";
import OpenPltformShowSubCategoryPageNew from "./Componant/AllPosts/OpenPltformShowSubCategoryPageNew";
import OpenPltformCategoryPostNew from "./Componant/AllPosts/OpenPltformCategoryPostNew";
import OpenPlatformSearchResultNew from "./Componant/AllPosts/OpenPlatformSearchResultNew";
import MyTickets from "./Componant/AllPosts/MyTickets";
import CallbackFunc from "./Componant/AllPosts/CallbackFunc";
import TokenManager from "./Componant/AllPosts/TokenManager";
import ManageProjectPlatform from "./Componant/AllPosts/ManageProjectPlatform";
import NonplatfromUsers from "./Componant/AllPosts/NonplatfromUsers";
import ManageCredentials from "./Componant/AllPosts/ManageCredentials";
import ZohoIntegration from "./Componant/ZohoIntegration";
import TicketingPlatformSelector from "./Componant/TicketingPlatformSelector";
import { useNavigate } from "react-router-dom";
import VideoTranscript from "./Componant/VideoTranscript";
import YoutubeVideoTranscript from "./Componant/YoutubeVideoTranscript";
import TranscriptMain from "./Componant/TranscriptMain";
import TenantConfigarationCred from "./Componant/TenantConfigaration/TenantConfigarationCred";
import TenantConfigTable from "./Componant/TenantConfigaration/TenantConfigTable";
function App() {
  const { setLogoutModal, setSettingsDropdown } = useContext(GlobalContext);
  // const [userLogedIn, setUserLogedIn] = useState(false)
  const [openPlatform, setOpenPlatform] = useState("");
  const [loading, setLoading] = useState(false);
  const [campraImg, setCampraImg] = useState(localStorage.getItem("logoImg"));

  let userLogedIn = localStorage.getItem("jwt_token");
  // console.log("40=", userLogedIn);
  // console.log("parenurlappl60=", window.parent.location);
  // const
  // console.warn("testwarn");

  // set fav icon dynamically start
  const updateFavicon = (faviconUrl) => {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = faviconUrl;
    document.getElementsByTagName("head")[0].appendChild(link);
    const fabIconLink =
      document.getElementById("faIconLink") || document.createElement("link");
    fabIconLink.id = "fabIconLink";
    fabIconLink.rel = "icon";
    document.getElementsByTagName("head")[0].appendChild(fabIconLink);
  };
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/fav-icon`, {
        headers: {
          // Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("line33=", res);
        // localStorage.setItem("logoImg", res.data);
        updateFavicon(res.data);
      });
  }, []);
  // set fav icon dynamically end

  const config = {
    headers: {
      Authorization: `Bearer ${userLogedIn}`,
      "Content-Type": "application/json",
    },
  };
  //
  // const updateFavicon = (faviconUrl) => {
  //   const link =
  //     document.querySelector("link[rel*='icon']") ||
  //     document.createElement("link");
  //   link.type = "image/x-icon";
  //   link.rel = "shortcut icon";
  //   link.href = faviconUrl;
  //   document.getElementsByTagName("head")[0].appendChild(link);
  // };
  // useEffect(() => {
  //   axios
  //     .get(`${API_BASE_URL}/wp-json/custom/v1/image`, {
  //       // headers: {
  //       //   'Authorization': `Bearer ${bearerToken}`,
  //       //   'Content-Type': 'application/json',
  //       // }
  //     })
  //     .then((res) => {
  //       console.log("line33=", res);
  //       localStorage.setItem("logoImg", res.data);
  //       setCampraImg(res.data);
  //       updateFavicon(res.data);
  //     });
  // }, [campraImg]);
  //
  //
  const [sessionData, setSessionData] = useState(null);
  const [error, setError] = useState(null);
  //

  // useEffect(() => {
  //   window.addEventListener("beforeunload", alertUser);
  //   window.addEventListener("unload", handleEndConcert);
  //   return () => {
  //     window.removeEventListener("beforeunload", alertUser);
  //     window.removeEventListener("unload", handleEndConcert);
  //     handleEndConcert();
  //   };
  // }, []);

  //
  // useEffect(() => {
  //   const fetchIpAddress = async () => {
  //     try {
  //       const response = await axios.get("https://api.ipify.org?format=json");
  //       const ipAddress = response.data.ip;

  //       // Generate a unique tab ID
  //       const tabId = sessionStorage.getItem("tab_id") || Date.now().toString();
  //       sessionStorage.setItem("tab_id", tabId);

  //       // Manage session
  //       const sessionResponse = await axios.post(
  //         `${API_BASE_URL}/wp-json/custom/v1/manage_session`,
  //         {
  //           ip_address: ipAddress,
  //           tab_id: tabId,
  //         }
  //       );

  //       if (sessionResponse.status === 403) {
  //         setError(sessionResponse.data.error);
  //       } else {
  //         const newSessionData = {
  //           ...sessionResponse.data,
  //           ip_address: ipAddress,
  //         };
  //         sessionStorage.setItem(
  //           "session_data",
  //           JSON.stringify(newSessionData)
  //         );
  //         setSessionData(newSessionData);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching IP address or managing session:", error);
  //     }
  //   };

  //   fetchIpAddress();
  //   console.log("tabId=", sessionStorage.getItem("tab_id"));

  //   // const handleBeforeUnload = async () => {
  //   //   alert("sdfsdf");
  //   //   const tabId = sessionStorage.getItem("tab_id");
  //   //   if (tabId) {
  //   //     await axios.post(`${API_BASE_URL}/wp-json/custom/v1/end_session`, {
  //   //       tab_id: tabId,
  //   //     });
  //   //     sessionStorage.removeItem("tab_id");
  //   //   }
  //   // };

  //   // window.addEventListener("beforeunload", handleBeforeUnload);

  //   // return () => {
  //   //   window.removeEventListener("beforeunload", handleBeforeUnload);
  //   // };

  //   //

  //   window.addEventListener("beforeunload", alertUser);
  //   window.addEventListener("unload", handleEndConcert);
  //   return () => {
  //     window.removeEventListener("beforeunload", alertUser);
  //     window.removeEventListener("unload", handleEndConcert);
  //     handleEndConcert();
  //   };
  //   //
  // }, []);
  useEffect(() => {
    const k = setTimeout(() => {
      console.log("in next window.KR", window.KR);
      window.KR("update", {
        apiBase:
          (window.location.origin.includes("localhost")
            ? "http://localhost:3060"
            : window.location.origin + "/backend_cosmos") +
          "/widget/commonScript",
        displayName: localStorage.getItem("display_name"),
        userEmail: localStorage.getItem("userEmail"),
      });
    }, 1000);
    return () => clearTimeout(k);
  }, []);
  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
  };
  const handleEndConcert = async () => {
    const tabId = sessionStorage.getItem("tab_id");

    if (tabId) {
      await axios.post(`${API_BASE_URL}/wp-json/custom/v1/end_session`, {
        tab_id: tabId,
      });
      // alert("dfdg");
      sessionStorage.removeItem("tab_id");
    }

    // if (tabId) {
    //   const data = JSON.stringify({ tab_id: tabId });
    //   navigator.sendBeacon(
    //     `${API_BASE_URL}/wp-json/custom/v1/end_session`,
    //     data
    //   );
    //   sessionStorage.removeItem("tab_id");

    // }
  };

  // if (error) {
  //   return <div>{error}</div>;
  // }
  //
  const navigate = useNavigate();
  const getOpenPlatformValue = () => {
    console.log("line266=", API_BASE_URL);
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/toggle-option`, config)
      .then((res) => {
        setOpenPlatform(res.data.value ? "true" : "false");
        setLoading(true);
      })
      .catch((err) => {
        navigate("/");
        setLoading(true);
        console.log(err);
      });
  };
  console.log("session=", sessionData);
  useEffect(() => {
    getOpenPlatformValue();
  }, [openPlatform]);
  //
  if (error) {
    return <div>{error}</div>;
  }
  //
  console.log("sessionData=", sessionData);
  console.log("line85=", localStorage.getItem("tabCount"));
  // alert(parseInt(localStorage.getItem("tabCount")) > 1);
  let tabCount = parseInt(localStorage.getItem("tabCount"));
  const isPrompt = () => {
    return "sdfsfsfs";
  };
  return (
    <div
      className=""
      onClick={() => {
        setLogoutModal(false);
        setSettingsDropdown(false);
      }}
    >
      <div style={{ minHeight: "93vh" }}>
        {/* <Container>
        <prompt
          when={isPrompt()}
          message={() => "Are you sure you want to leave this page?"}
        />
      </Container>

      <div>
        <h1>Concurrent Session Management</h1>
        {sessionData ? (
          <div>
            <p>
              Session Start:{" "}
              {new Date(sessionData.session_start * 1000).toLocaleString()}
            </p>
            <p>Page Views: {sessionData.views}</p>
          </div>
        ) : (
          <p>Loading session data...</p>
        )}
      </div> */}
        {/* {alert(loading)} */}
        {/*  */}
        {loading ? (
          <div>
            {openPlatform == "true" && !userLogedIn ? (
              <div>
                {/* {tabCount < 3 ? ( */}
                <Routes>
                  {/* <Route path="/" Component={OpenPlatformSearchLandingPage} /> */}
                  <Route path="/" Component={OpenPltformSearchLandingPageNew} />
                  {/* <Route
                  path="/subcategory"
                  Component={OpenPlatformShowSubCategory}
                /> */}
                  <Route
                    path="/subcategory"
                    Component={OpenPltformShowSubCategoryPageNew}
                  />
                  {/* <Route path="/results" Component={OpSearchResults} /> */}
                  <Route
                    path="/results"
                    Component={OpenPlatformSearchResultNew}
                  />
                  <Route
                    path="/analytics-dashboard"
                    Component={OpAnaliticsDasboard}
                  />
                  <Route
                    path="/single-article"
                    Component={OpenPlatformSingleArticle}
                  />
                  {/* <Route
                  path="/category-posts"
                  Component={OpenPlatformCategoryPost}
                />
              </Routes> */}
                  <Route
                    path="/category-posts"
                    Component={OpenPltformCategoryPostNew}
                  />
                </Routes>
                {/* ) : (
                <h4 className="text-center pt-5">
                  {" "}
                  You used maximum number of session
                </h4>
              )} */}
                <Routes>
                  <Route path="/login" Component={Login} />
                  <Route path="/otp" Component={Otp} />
                </Routes>
              </div>
            ) : (
              <Routes>
                <Route
                  path="/single-article-widget"
                  Component={WidgetSingleArticles}
                />

                <Route path="/results/:id" component={SearchResults} />
                <Route path="/all-articles" Component={KrLanding} />
                {userLogedIn !== null ? (
                  <Route path="/" Component={SearchLandingPageNew} />
                ) : (
                  <Route path="/" Component={Login} />
                )}
                <Route path="/log" Component={LoggerFile} />
                <Route path="/otp" Component={Otp} />
                {/* <Route path="/default-page" Component={SearchLandingPage} /> */}
                <Route path="/default-page" Component={SearchLandingPageNew} />
                <Route path="/post" Component={Posts} />
                <Route
                  path="/search-landingPage"
                  Component={SearchLandingPage}
                />
                <Route path="/table-posts" Component={TablePosts} />
                {/* <Route path="/table-posts" Component={BackupTable} /> */}
                <Route path="/single-post" Component={SinglePost} />
                {/* 8-Pages */}
                <Route path="/tablePosts2" Component={TablePost2nd} />
                {/* <Route path="/editPost" Component={Postedit} /> */}
                <Route path="/create-post" Component={Editor} />
                <Route path="/edit-post" Component={EditPostScreen} />
                {/* <Route path="/ticktes" Component={MyTickets} /> */}
                {/* <Route path="/tickets" Component={TokenManager} /> */}
                {/* <Route path="/tickets" Component={JiraIntegration} /> */}
                {/* <Route path="/tickets" Component={ZohoIntegration} /> */}
                <Route path="/tickets" Component={TicketingPlatformSelector} />
                <Route
                  path="/issue-project"
                  Component={ManageProjectPlatform}
                />
                <Route path="/video-transcript" Component={VideoTranscript} />
                <Route
                  path="/youtube-video-transcript"
                  Component={YoutubeVideoTranscript}
                />
                <Route path="/transcript" Component={TranscriptMain} />
                <Route
                  path="/manage-credential"
                  Component={ManageCredentials}
                />
                <Route path="/callback" Component={CallbackFunc} />
                {/* end-8-pages */}
                {/* <Route path="/results" Component={SearchResults} /> */}
                <Route path="/results" Component={SearchResultesNew} />
                <Route
                  path="/manage-open-platform"
                  Component={SetOpenPlatform}
                />

                <Route path="/single-article" Component={SingleArticle} />
                {/* <Route path="/create-post" Component={CreatePost} /> */}
                <Route
                  path="/create-new-user-form"
                  Component={CreateNewUserForm}
                />
                <Route
                  path="/CreateUsersUsingCsv"
                  Component={CreateUsersUsingCsv}
                />
                <Route path="/postCreator" Component={PostCreator} />
                <Route path="/img" Component={ImageUpload} />
                <Route path="/getAllCat" Component={GetAllCat} />
                <Route path="/getAllCatNew" Component={GetAllNew} />
                <Route path="/csv" Component={CsvDownloader} />
                {/* <Route path="/create-subcategory" Component={CreateCatagory} /> */}
                <Route
                  path="/create-subcategory"
                  Component={CreateCategories}
                />
                <Route path="/create-tag" Component={CreateTags} />
                {/* <Route path="/category-posts" Component={CategoryPosts} /> */}
                <Route path="/category-posts" Component={CategoryPostsNew} />
                <Route path="/widget-admin" Component={WigetAdmin} />
                {/* <Route path="/subcategory" Component={ShowSubCategory} /> */}
                <Route path="/subcategory" Component={ShowSubCategoryNew} />
                <Route path="/logo" Component={GlobalLogo} />
                <Route
                  path="/analytics-dashboard"
                  Component={AnaliticsDasboard}
                />
                <Route path="/notification" Component={Notifications} />
                <Route path="/broadcast" Component={BroadCast} />
                <Route
                  path="/widget-installation-guide"
                  Component={CreateOraUsers}
                />
                <Route path="/login-access" Component={NonplatfromUsers} />
                <Route path="/create-script" Component={CreateScript} />
                <Route path="/tenant-configaration" Component={TenantConfigarationCred} />
                <Route path="/tenant-config" Component={TenantConfigTable} />

                {/* <Route path="/landing" Component={KrLanding} /> */}
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            )}
          </div>
        ) : (
          <div className="text-center pt-5">
            <Spinner />
          </div>
        )}
      </div>
      <Footer />
      <TopArrowButton />
      {/* <InitalizeWidget /> */}
    </div>
  );
}

export default App;
